import cn from 'classnames';
import styles from './MoreButton.module.scss';

type MoreButtonProps = {
  className?: string;
  text: string;
  onClick: () => void;
};

export function MoreButton({ className, text, onClick }: MoreButtonProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName} onClick={onClick}>
      <span className={styles.text}>{text}</span>
      <img src="/svg/chevron-black.svg" alt="arrow" className={styles.icon} />
    </div>
  );
}
